import { useLegal } from '@/context/LegalContext';
import LegalPageLayout from '../LegalPageLayout';

export default function TermsPage() {
  const { settings } = useLegal();
  return (
    <LegalPageLayout
      page={settings.terms}
      seoTitle="Terms of Use | Stingray Marine Batteries"
      seoDescription="Read Stingray Marine's terms of use for the stingray-marine.com website. Understand your rights and responsibilities when using our site."
      canonical="https://stingray-marine.com/terms"
      breadcrumb="Terms of Use"
    />
  );
}
